import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Award, Shield, Wrench } from "lucide-react";

const AboutSection = () => {
  const ref = useScrollReveal();

  return (
    <section id="about" className="py-20 bg-background" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto animate-on-scroll">
          <div className="bg-card rounded-2xl shadow-lg p-8 md:p-12 border border-border">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6 text-center">
              הכירו את <span className="text-primary">אור</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8 text-center max-w-3xl mx-auto">
              שמי אור, ואני חי ונושם גגות כבר 13 שנה. התחלתי מלמטה – מהבורג הראשון ועד לפרויקטים
              המורכבים ביותר. היום, אני מתחייב לפתור <strong className="text-foreground">99% מבעיות הגג</strong> שתיתקלו
              בהן. המומחיות שלי משלבת ידע הנדסי עמוק עם גישה אישית ומחויבות מוחלטת לתוצאה מושלמת.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { icon: Award, title: "13 שנות ניסיון", desc: "מומחיות שנבנתה פרויקט אחרי פרויקט" },
                { icon: Shield, title: "אחריות מלאה", desc: "עומדים מאחורי כל עבודה שאנחנו מבצעים" },
                { icon: Wrench, title: "פתרון 99%", desc: "כמעט כל בעיית גג – יש לנו את הפתרון" },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center text-center p-4">
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                    <item.icon className="text-primary" size={28} />
                  </div>
                  <h3 className="font-bold text-foreground mb-1">{item.title}</h3>
                  <p className="text-sm text-muted-foreground">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
